import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, setAdminToken } from "../lib/adminApi";
import { toast } from "sonner";

export default function AdminLogin() {
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await adminApi.post("/login", {
                email,
                password,
            });
            setAdminToken(data.token);
            toast.success("Welcome back.");
            nav("/admin");
        } catch (err) {
            toast.error(
                err.response?.data?.detail || "Invalid credentials",
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="min-h-[80vh] flex items-center justify-center px-6"
            data-testid="admin-login-page"
        >
            <form
                onSubmit={submit}
                className="w-full max-w-md p-10"
                style={{
                    background: "var(--vl-surface)",
                    border: "1px solid var(--vl-border)",
                }}
                data-testid="admin-login-form"
            >
                <div className="overline mb-4">Veloura · Atelier console</div>
                <h1
                    className="font-serif text-4xl tracking-tight mb-8"
                    style={{ color: "var(--vl-text)" }}
                >
                    Admin{" "}
                    <em
                        style={{
                            color: "var(--vl-rose)",
                            fontStyle: "italic",
                        }}
                    >
                        sign-in.
                    </em>
                </h1>
                <div className="space-y-6">
                    <input
                        required
                        type="email"
                        placeholder="Admin email"
                        className="vl-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        data-testid="admin-email"
                        autoComplete="username"
                    />
                    <input
                        required
                        type="password"
                        placeholder="Password"
                        className="vl-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        data-testid="admin-password"
                        autoComplete="current-password"
                    />
                </div>
                <button
                    type="submit"
                    disabled={loading}
                    className="vl-btn vl-btn-solid w-full justify-center mt-10"
                    data-testid="admin-login-submit"
                >
                    {loading ? "Signing in…" : "Sign in"}
                </button>
                <p
                    className="text-[11px] mt-6"
                    style={{ color: "var(--vl-muted)" }}
                >
                    Restricted access. All activity is logged.
                </p>
            </form>
        </div>
    );
}
